module.exports = __webpack_public_path__ + "static/media/chocolat.4200b6b9.jpeg";